export default {
  gettoken: state => state.login.token
}
